interface CloudLikeSunSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloudLikeSunSVG = ({ color, style }: CloudLikeSunSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12428)">
      <path
        d="M35.9539 25.2529C37.5848 25.7132 38.7869 27.2178 38.7869 28.9907C38.7869 31.1266 37.0403 32.8757 34.9044 32.8757H16.5392C14.4033 32.8757 12.6567 31.1266 12.6567 28.9907C12.6567 26.8548 14.3796 25.1293 16.5023 25.1083C16.3892 24.8242 16.3287 24.5138 16.3287 24.1903C16.3287 22.7962 17.4598 21.6651 18.8539 21.6651C19.138 21.6651 19.4089 21.7098 19.6614 21.7966C20.4058 19.1584 22.8284 17.2277 25.7034 17.2277C27.9629 17.2277 29.9435 18.4219 31.0483 20.2158C31.4613 20.0632 31.9084 19.9817 32.374 19.9817C34.4993 19.9817 36.2249 21.7046 36.2249 23.8325C36.2249 24.3349 36.1276 24.8137 35.9539 25.2529Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7222 6.61153C27.3688 6.61153 28.7129 5.27004 28.7129 3.62079C28.7129 1.97155 27.3688 0.63269 25.7222 0.63269C24.0756 0.63269 22.7314 1.97418 22.7314 3.62079C22.7314 5.26741 24.0756 6.61153 25.7222 6.61153Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4805 13.1403C43.1271 13.1403 44.4712 11.7962 44.4712 10.1495C44.4712 8.50293 43.1271 7.15881 41.4805 7.15881C39.8339 7.15881 38.4897 8.50293 38.4897 10.1495C38.4897 11.7962 39.8339 13.1403 41.4805 13.1403Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.009 28.8987C49.6557 28.8987 50.9998 27.5546 50.9998 25.908C50.9998 24.2614 49.6557 22.9172 48.009 22.9172C46.3624 22.9172 45.0183 24.2614 45.0183 25.908C45.0183 27.5546 46.3624 28.8987 48.009 28.8987Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4805 44.6572C43.1271 44.6572 44.4712 43.3131 44.4712 41.6665C44.4712 40.0199 43.1271 38.6758 41.4805 38.6758C39.8339 38.6758 38.4897 40.0199 38.4897 41.6665C38.4897 43.3131 39.8339 44.6572 41.4805 44.6572Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7222 51.1831C27.3688 51.1831 28.7129 49.8416 28.7129 48.195C28.7129 46.5483 27.3688 45.2042 25.7222 45.2042C24.0756 45.2042 22.7314 46.5457 22.7314 48.195C22.7314 49.8442 24.0756 51.1831 25.7222 51.1831Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96315 44.6572C11.6098 44.6572 12.9539 43.3131 12.9539 41.6665C12.9539 40.0199 11.6098 38.6758 9.96315 38.6758C8.31653 38.6758 6.97241 40.0199 6.97241 41.6665C6.97241 43.3131 8.31653 44.6572 9.96315 44.6572Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.43464 28.8987C5.08388 28.8987 6.42537 27.5546 6.42537 25.908C6.42537 24.2614 5.08388 22.9172 3.43464 22.9172C1.78539 22.9172 0.446533 24.2614 0.446533 25.908C0.446533 27.5546 1.78802 28.8987 3.43464 28.8987Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96315 13.1403C11.6098 13.1403 12.9539 11.7962 12.9539 10.1495C12.9539 8.50293 11.6098 7.15881 9.96315 7.15881C8.31653 7.15881 6.97241 8.50293 6.97241 10.1495C6.97241 11.7962 8.31653 13.1403 9.96315 13.1403Z"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.235 20.4209L12.0782 12.2642M6.42554 25.9079H14.1851"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7009 20.0395L39.3658 12.2641M25.722 6.61145L25.7036 17.2276"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.6873 32.8757L39.3658 39.5516M45.0158 25.9078H37.2562"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7566 32.8759L12.0781 39.5517M25.7219 34.9302V32.8759M25.7219 45.2044V33.9017"
        stroke={color}
        strokeWidth="0.893218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12428">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudLikeSunSVG;
